import { render } from "./ModalUserProfile.vue?vue&type=template&id=511cbf9d"
import script from "./ModalUserProfile.vue?vue&type=script&lang=js"
export * from "./ModalUserProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__